"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NumberFormatter {
    /**
   * Formats number.
   * @param {data}
   * @param {args} : array of references to be rounded to two decimals
   * @returns {string}
   * For more complex implementations of number formatters, please, check other projects
   * I.E. SPC, Checkout, Mini-Spc
   */
    format(data, args) {
        args.forEach(arg => {
            if (data.questionReference === arg) {
                data.answerValue = Number(data.answerValue).toFixed(2);
            }
        });
        return data.answerValue;
    }
}
exports.default = NumberFormatter;
